// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.CommandButton
 * @extends Jsw.Component
 */
export const CommandButton = Class.create(Component, {
    _initConfiguration($super, config) {
        $super(config);

        this._handler = this._getConfigParam('handler', false);
        if (Object.isString(this._handler)) {
            // eslint-disable-next-line no-eval
            eval(`this._handler = ${this._handler}`);
        }

        this._value = this._config.value || '';
        this._tabIndex = this._getConfigParam('tabIndex', null);
    },

    _initComponentElement($super) {
        $super();

        const buttonElement = new Element('button', {
            type: 'button',
            value: this._value,
            name: this._config.name,
        }).update(this._config.title);

        if (null !== this._tabIndex) {
            buttonElement.writeAttribute('tabindex', this._tabIndex);
        }

        this._updateComponentElement(buttonElement);

        this._initVisibility();
    },

    _initVisibility() {
        this._disabled = this._getConfigParam('disabled', false);

        if (this._disabled) {
            this._disabled = false;
            this.disable();
        } else {
            this._disabled = true;
            this.enable();
        }
    },

    enable() {
        if (!this._disabled) {
            return;
        }

        this._disabled = false;
        if ('send' === this._config.name || 'apply' === this._config.name) {
            this._componentElement.addClassName('action');
        }
        this._componentElement.removeClassName('disabled');
        this._componentElement.disabled = false;
        if (this._handler) {
            this.addEventObserver('click', this._handler);
        }
    },

    disable() {
        if (this._disabled) {
            return;
        }

        this._disabled = true;
        this._componentElement.disabled = true;
        if ('send' === this._config.name || 'apply' === this._config.name) {
            this._componentElement.removeClassName('action');
        }
        this._componentElement.addClassName('disabled');
        if (this._handler) {
            this.removeEventObserver('click', this._handler);
        }
    },
});



// WEBPACK FOOTER //
// ./jsw/command-button.js